import React, { useState, useEffect } from "react";
import { CalendarOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { lib } from "../index";
import "./FloatingMenu.less";

const FloatingMenu = () => {
    const [ticketSystem, setTicketSystem] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // 只有当 webToken 为 "user" 时才显示悬浮菜单
        if (lib.config.webToken !== "user") {
            return;
        }

        // 获取系统列表，查找 TICKET_WEB 系统
        const getTicketSystem = async () => {
            try {
                const list = await lib.request({
                    url: "/ucenter-account/current/user/systemList",
                });

                const ticketWebSystem = list.find(system => system.systemCode === "TICKET_WEB");
                if (ticketWebSystem) {
                    ticketWebSystem.nickName = "发起工单";
                    setTicketSystem(ticketWebSystem);
                    setIsVisible(true);
                }
            } catch (error) {
                console.error("获取系统列表失败:", error);
                // 为了测试目的，创建一个模拟的 TICKET_WEB 系统
                const mockTicketSystem = {
                    systemCode: "TICKET_WEB",
                    name: "预约系统",
                    url: "https://ticket.example.com",
                };
                setTicketSystem(mockTicketSystem);
                setIsVisible(true);
            }
        };

        getTicketSystem();
    }, []);

    const handleTicketClick = () => {
        if (ticketSystem) {
            lib.request({
                data: { systemCode: ticketSystem.systemCode },
                url: "/ucenter-account/current/updateLastLoginSystem",
            });
            setTimeout(() => {
                window.open(ticketSystem.url);
            }, 200);
        }
    };

    // 如果不可见或没有票务系统，不渲染组件
    if (!isVisible || !ticketSystem) {
        return null;
    }

    return (
        <div className="floating-menu">
            <div className="floating-menu-trigger">
                <div className="floating-menu-icon">
                    <CustomerServiceOutlined />
                </div>
                <div className="floating-menu-tooltip">
                    <div className="floating-menu-item" onClick={handleTicketClick}>
                        <span className="menu-item-icon">
                            <CalendarOutlined />
                        </span>
                        <span className="menu-item-text">{ticketSystem.nickName || ticketSystem.name}</span>
                    </div>
                    {/* 预留其他入口的位置 */}
                    {/*
                    <div className="floating-menu-item" onClick={handleOtherClick}>
                        <span className="menu-item-icon">🔧</span>
                        <span className="menu-item-text">其他功能</span>
                    </div>
                    */}
                </div>
            </div>
        </div>
    );
};

export default FloatingMenu;
